import { Mark, mergeAttributes } from '@tiptap/core';

type TooltipOptions = {
  HTMLAttributes: Record<string, any>;
};

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    tooltip: {
      /**
       * Set a tooltip mark
       */
      setTooltip: (attributes?: { title: string }) => ReturnType;
      /**
       * Toggle a tooltip mark
       */
      toggleTooltip: (attributes?: { title: string }) => ReturnType;
      /**
       * Unset a tooltip mark
       */
      unsetTooltip: () => ReturnType;
    };
  }
}

const Tooltip = Mark.create<TooltipOptions>({
  name: 'tooltip',

  addOptions() {
    return {
      HTMLAttributes: {
        class: 'tooltip-mark'
      }
    };
  },

  addAttributes() {
    return {
      title: {
        default: ''
      }
    };
  },

  parseHTML() {
    return [{ tag: 'span[data-tooltip]' }];
  },

  renderHTML({ HTMLAttributes }) {
    return [
      'span',
      mergeAttributes(this.options.HTMLAttributes, HTMLAttributes, {
        'data-tooltip': HTMLAttributes.title
      }),
      0
    ];
  },

  addCommands() {
    return {
      setTooltip:
        (attributes) =>
        ({ commands }) => {
          return commands.setMark(this.name, attributes);
        },
      toggleTooltip:
        (attributes) =>
        ({ commands }) => {
          return commands.toggleMark(this.name, attributes);
        },
      unsetTooltip:
        () =>
        ({ commands }) => {
          return commands.unsetMark(this.name);
        }
    };
  }
});

export default Tooltip;
